export const ROUTERS = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  PRODUCT: '/products',
  PROD_DETAIL: '/product/:id',
  CART: '/carts',
}